import React from "react";

const Layout: React.FC = () => {
  return <main />;
};

export default Layout;
